import {Component, inject} from '@angular/core';
import {CsrfTokenService} from "./common/services/csrf-token.service";
import {DecoratorService} from "./common/services/decorator.service";
import {NgEventBus} from "ng-event-bus";
import {AuthService} from "./common/services/auth.service";
import {PusherService} from "./services/pusher.service";
import {TopLoaderService} from "./common/services/top-loader.service";
import {PUSHER_CONNECTED, USER_LOGIN} from "./common/app-events";
import {RouterOutlet} from "@angular/router";
import {Toast} from "primeng/toast";
import {ConfirmDialog} from "primeng/confirmdialog";
import {BreakService} from "./common/services/break.service";
import {AppUpdateService} from "./services/app-update.service";


@Component({
  selector: 'app-root',
  template: `
    @if (topLoaderService.visible) {
      <div class="indeterminate-progress-bar">
        <div class="indeterminate-progress-bar__progress"></div>
      </div>
    }
    <div class="h-full max-w-none">
      <router-outlet></router-outlet>
    </div>
    <p-toast position="top-center"></p-toast>
    <p-confirmDialog title="Confirm"></p-confirmDialog>

     

  `,
  imports: [
    RouterOutlet,
    Toast,
    ConfirmDialog
  ]
})
export class AppComponent {
  title = 'primeasia-rooster';
  public pusherState ?: string;
  public previousState ?: string;
  public breakService = inject(BreakService)
  private appUpdateService = inject(AppUpdateService);

  constructor(
    public csrfTokenService: CsrfTokenService,
    public decoratorService: DecoratorService,
    public authService: AuthService,
    public eventBus: NgEventBus,
    public pusherService: PusherService,
    public topLoaderService: TopLoaderService,
  ) {


// Initialize Firebase

    //this.csrfTokenService.getToken().subscribe();

    if (this.authService.loggedIn()) {
      this.eventBus.cast(USER_LOGIN, this.authService.user);
      this.eventBus.cast(PUSHER_CONNECTED);
      this.pusherService.connectToChannel('presence-users');
      eventBus.on(PUSHER_CONNECTED).subscribe(res => {
        this.pusherService.connectToChannel('private-user.' + this.authService.user.id)
      })
    }

  }


  endBreak() {
    this.eventBus.cast('end:break');
  }
}

